// extracted by mini-css-extract-plugin
export var label = "_e2-2";
export var slideContainer = "_e2-0";
export var slider = "_e2-1";